<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Inv Date </em>
				<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>

				<em class="lt_text">Exclude SalesGroup </em>
				<span class="int_type_no_border mgr_15">
					<CodeSelectMultiS :showDesc="false" :width="100" :codes="salesGroups" v-model="excludeSalesGroups" :separator="separator" />
				</span>

				<em class="lt_text">Exclude Color </em>
				<span class="int_type_no_border mgr_15">
					<CodeSelectMultiS :showDesc="false" :width="100" :codes="colors" v-model="excludeColors" :separator="separator" />
				</span>

				<a href="javascript: void(0);" class="search_bt" @click="getData">Search</a>
				<a v-if="result_list.length > 0" href="javascript: void(0);" class="gray_bt" @click="excelExport">Excel</a>
			</div>
		</div>

		<table v-if="result_list.length > 0" id="salesGoodsBySalesGroup">
			<tr>
				<td style="vertical-align: top; width: 10%;">
					<div style="overflow-y: hidden; overflow-x: hidden;">
						<table class="list_tbl" style="table-layout: fixed;">
							<thead>
								<tr>
									<th class="truncate border_right">{{ invoice_date_from }} ~ {{ invoice_date_to }}</th>
								</tr>
								<tr>
									<th class="truncate border_right">{{ headers.class }} Name</th>
								</tr>
							</thead>
						</table>
					</div>
				</td>
				<td style="vertical-align: top; width: 90%;">
					<div ref="rightHeader" style="overflow-y: hidden; overflow-x: hidden; width: 100%; padding-right: 17px;">
						<table class="list_tbl" :style="{ 'table-layout': 'fixed', width: 'calc(' + (filteredSalesGroup.length + 1) * 15 + '% + 17px)' }">
							<thead>
								<tr>
									<th class="truncate border_right" colspan="3" v-for="(sg, index) in filteredSalesGroup" :key="index">{{ sg.name }}</th>
									<th class="border_right" colspan="3">Total</th>
									<th class="border_none" style="width: 17px;"></th>
								</tr>
								<tr>
									<template v-for="i in filteredSalesGroup.length + 1">
										<th class="truncate border_right" :key="i + 'qty'">Sum Qty</th>
										<th class="truncate border_right" :key="i + 'amt'">Sum Amt</th>
										<th class="truncate border_right" :key="i + 'price'">Avg Price</th>
									</template>
									<th class="border_none" style="width: 17px;"></th>
								</tr>
							</thead>
						</table>
					</div>
				</td>
			</tr>

			<tr>
				<td style="vertical-align: top; width: 10%;">
					<div ref="leftContent" style="overflow-y: hidden; overflow-x: hidden; vertical-align: top; height: 700px;">
						<table class="list_tbl" style="table-layout: fixed;">
							<tbody>
								<tr v-for="(res, index) in result_list" :key="index">
									<td class="truncate border_right">{{ res.class_name }}</td>
								</tr>
								<tr>
									<td class="border_none" style="height: 17px;"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
				<td style="vertical-align: top; width: 90%;">
					<div ref="rightContent" style="overflow-x:scroll; overflow-y:scroll; width: 100%; height: 700px;" @scroll="dataOnScroll">
						<table class="list_tbl" :style="{ 'table-layout': 'fixed', width: 'calc(' + (filteredSalesGroup.length + 1) * 15 + '%' }">
							<tbody>
								<tr v-for="(res, index) in result_list" :key="index">
									<template v-for="(sg, jIndex) in filteredSalesGroup">
										<td class="truncate al_right" :key="index + '/' + jIndex + '/' + 0">{{ res[sg.code + '_sum_qty'] | commaSeparated }}</td>
										<td class="truncate al_right" :key="index + '/' + jIndex + '/' + 1">{{ res[sg.code + '_sum_amt'] | toCurrency }}</td>
										<td class="truncate al_right" :key="index + '/' + jIndex + '/' + 2">{{ res[sg.code + '_avg_price'] | toCurrency }}</td>
									</template>
									<td class="truncate al_right" :key="index + '_sum_qty'">{{ res.total_sum_qty | commaSeparated }}</td>
									<td class="truncate al_right" :key="index + '_sum_amt'">{{ res.total_sum_amt | toCurrency }}</td>
									<td class="truncate al_right" :key="index + '_avg_price'">{{ res.total_avg_price | toCurrency }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import CodeSelectMultiS from '@/components/common/CodeSelectMultiS';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { apiIndex, apiSelectSalesGoodsBySalesGroup } from '@/api/report/report.js';
import { today } from '@/utils/date';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import { fixDecimalPlace } from '@/utils/etc';
export default {
	data: () => ({
		salesGroups: [],
		colors: [],
		separator: ',',

		excludeSalesGroups: '',
		excludeSalesGroupsArr: [],
		filteredSalesGroup: [],
		excludeColors: '',
		invoice_date_from: '',
		invoice_date_to: '',

		result_list: [],
	}),
	components: {
		CodeSelectMultiS,
		CustomDatePicker,
	},
	props: ['headers'],
	methods: {
		excelExport() {
			if (!this.result_list || !this.result_list.length) return this.$toast.error('No List To Export');

			// , headerStyle: { fill: { fgColor: { rgb: 'FFFF00' } } } <= header cell 노란색으로 하는 것 포기
			const fileName = 'salesGoodsBySalesGroup';
			const headerGroups = [{ key: 'period', name: this.invoice_date_from + '~' + this.invoice_date_to }];
			const headers = [{ key: 'class_name', name: `${this.headers.class} Name`, groupKey: 'period', width: 30 }];
			for (let i = 0; i < this.filteredSalesGroup.length; i++) {
				headerGroups.push({ key: this.filteredSalesGroup[i].code, name: this.filteredSalesGroup[i].name });
				headers.push({ key: this.filteredSalesGroup[i].code + '_sum_qty', name: 'Sum Qty', groupKey: this.filteredSalesGroup[i].code, width: 15, dataType: defaultDataType.currency });
				headers.push({ key: this.filteredSalesGroup[i].code + '_sum_amt', name: 'Sum Amt', groupKey: this.filteredSalesGroup[i].code, width: 15, dataType: defaultDataType.number });
				headers.push({ key: this.filteredSalesGroup[i].code + '_avg_price', name: 'Avg Price', groupKey: this.filteredSalesGroup[i].code, width: 15, dataType: defaultDataType.number });
			}
			headerGroups.push({ key: 'total', name: 'Total' });
			headers.push({ key: 'total_sum_qty', name: 'Total Sum Qty', groupKey: 'total', width: 15, dataType: defaultDataType.currency });
			headers.push({ key: 'total_sum_amt', name: 'Total Sum Amt', groupKey: 'total', width: 15, dataType: defaultDataType.number });
			headers.push({ key: 'total_avg_price', name: 'Total Avg Price', groupKey: 'total', width: 15, dataType: defaultDataType.number });

			exportDataExcel(this.result_list, headers, fileName, headerGroups);
		},
		dataOnScroll: function() {
			let leftContent = this.$refs['leftContent'];
			let rightContent = this.$refs['rightContent'];
			let rightHeader = this.$refs['rightHeader'];

			leftContent.scrollTop = rightContent.scrollTop;
			rightHeader.scrollLeft = rightContent.scrollLeft;
		},
		sort(attr) {
			return function(a, b) {
				let nameA = a[attr].toUpperCase();
				let nameB = b[attr].toUpperCase();

				if (nameA < nameB) return -1;
				else if (nameA > nameB) return 1;
				else return 0;
			};
		},
		async getData() {
			if (!this.invoice_date_from || !this.invoice_date_to) {
				this.$toast.error('Please, Select Period');
				return;
			}

			this.excludeSalesGroupsArr = this.excludeSalesGroups ? this.excludeSalesGroups.split(this.separator) : [];
			this.filteredSalesGroup = this.salesGroups.filter(sg => !this.excludeSalesGroupsArr.some(xsg => xsg === sg.code)).sort(this.sort('name'));
			const { data } = await apiSelectSalesGoodsBySalesGroup(this.invoice_date_from, this.invoice_date_to, this.excludeSalesGroupsArr, this.excludeColors ? this.excludeColors.split(this.separator) : []);
			this.result_list = [];

			data.forEach(el => {
				if (this.result_list.findIndex(r => r.class_code === el.class_code) < 0) this.result_list.push({ class_code: el.class_code, class_name: el.class_name });
			});

			this.result_list.forEach(r => {
				let total_sum_qty = 0;
				let total_sum_amt = 0;
				this.filteredSalesGroup.forEach(sg => {
					let idx = data.findIndex(el => el.class_code === r.class_code && el.sales_group_code === sg.code);
					r[sg.code + '_sum_qty'] = idx > -1 ? data[idx].sum_qty : 0;
					r[sg.code + '_sum_amt'] = idx > -1 ? data[idx].sum_amt : 0;
					r[sg.code + '_avg_price'] = idx > -1 ? data[idx].avg_price : 0;

					total_sum_qty += r[sg.code + '_sum_qty'];
					total_sum_amt += r[sg.code + '_sum_amt'];
				});

				r.total_sum_qty = fixDecimalPlace(total_sum_qty, 0);
				r.total_sum_amt = fixDecimalPlace(total_sum_amt, 2);
				r.total_avg_price = total_sum_qty > 0 ? fixDecimalPlace(total_sum_amt / total_sum_qty, 2) : 0;
			});

			this.result_list = this.result_list.filter(r => r.total_sum_amt > 0);
			this.result_list.sort(this.sort('class_name'));
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList || [];
			this.colors = data.colorList || [];
		},
		async init() {
			this.invoice_date_from = today();
			this.invoice_date_to = today();

			this.index();
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_sales_goods_by_salesGroup');
		this.$store.commit('setSubTitle', 'Report -> Sales Goods by SalesGroup');

		this.init();
	},
};
</script>

<style>
.list_tbl .border_right {
	border-right: 1px solid #dbdbdb !important;
}
.border_none {
	border: none !important;
	background: none !important;
}
</style>
